export default __webpack_public_path__ + "static/media/careers3.e9ef7893.png";